/**
 * MyDataCompletenessStrip — лента на таблото: колко са попълнени „Моите данни",
 * кое е следващото липсващо и има ли просрочено изследване.
 * Данни: GET /api/my-data/status
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Database, AlertTriangle, ChevronRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MyDataCompletenessStrip({ isDark = false }) {
  const [d, setD] = useState(null);

  useEffect(() => {
    let live = true;
    axios.get(`${API}/my-data/status`)
      .then((r) => { if (live) setD(r.data); })
      .catch(() => { if (live) setD(null); });
    return () => { live = false; };
  }, []);

  if (!d?.summary) return null;
  const { complete, total, percent } = d.summary;

  return (
    <Link to="/dashboard/profile?tab=mydata"
      className={`block rounded-2xl border p-3 mb-4 transition hover:border-cyan-500/60 ${
        isDark ? "bg-slate-900/60 border-slate-800" : "bg-white border-slate-200"}`}
      data-testid="my-data-completeness-strip">
      <div className="flex items-center gap-3">
        <Database className="w-5 h-5 text-cyan-500 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="text-[12px] font-extrabold">
            Попълнени са {complete} от {total} групи данни
          </div>
          {d.next_step_bg && (
            <div className="text-[11px] opacity-75 truncate" data-testid="my-data-next-step">
              Следващо: {d.next_step_bg}
            </div>
          )}
          <div className={`mt-1.5 h-1.5 rounded-full overflow-hidden ${
            isDark ? "bg-white/10" : "bg-slate-200"}`}>
            <div className="h-full rounded-full bg-gradient-to-r from-cyan-500 to-emerald-500"
              style={{ width: `${percent}%` }} />
          </div>
        </div>
        <ChevronRight className="w-4 h-4 opacity-50 shrink-0" />
      </div>
      {!!d.overdue?.length && (
        <div className="mt-2 flex items-start gap-1.5 text-[11px]"
          data-testid="my-data-overdue">
          <AlertTriangle className="w-3.5 h-3.5 text-red-500 shrink-0 mt-0.5" />
          <span>
            <span className="font-bold text-red-500">Просрочено: </span>
            {d.overdue.map((o) => `${o.title_bg} (${o.status_bg})`).join(" · ")}
          </span>
        </div>
      )}
    </Link>
  );
}
